<template>
	<div class="setscheme" :style="{ height: `${windowHeight}px`}">
		<el-card class="box-card" label="" shadow="never" v-if="!showdetail">
			<div slot="header" class="clearfix"><span>系统提供以下方案类型</span> <span class="titletips">(如需添加新类型，请联系管理员)</span></div>
			<el-form class="schemecontent">
				<el-row>
					<el-col :span="24">
						<span v-for="(item, index) in typelist" :class="typeindex == index ? 'btnpaytype_hover' : 'btnpaytype'" v-on:mouseenter="showdescribe(index)" v-on:click="godetail(index)">{{item.d_name}}</span>
					</el-col>
				</el-row>
				<el-row v-if="typelist.length==0">
					<el-col :span="24">
						<p class="schemetilte redtitle">
							您没有可用的财务方案类型，请联系管理员授权
						</p>
					</el-col>
				</el-row>
			</el-form>
		</el-card>
		<el-row v-if="!showdetail">
			<el-col :span="24">
				<p class="schemetilte">{{name}}</p>
				<p class="schemedescribe">{{describe}}</p>
			</el-col>
		</el-row>
		<el-row>
			<BaseAddPercent ref="BaseAddPercent" v-show="cwinfo.p_type.toLocaleLowerCase()=='baseaddpercent'" @reback="reback"></BaseAddPercent>
			<ParentCostAddPercent ref="ParentCostAddPercent" v-show="cwinfo.p_type.toLocaleLowerCase()=='按上级成本价计算'" @reback="reback"></ParentCostAddPercent>
			<yuu ref="yuu" v-show="cwinfo.p_type.toLocaleLowerCase()=='云邮出口计费'" @reback="reback"></yuu>
			<DeductionPercent ref="DeductionPercent" v-show="cwinfo.p_type.toLocaleLowerCase()=='业务提成比例'" @reback="reback"></DeductionPercent>
			<xnd ref="xnd" v-show="cwinfo.p_type.toLocaleLowerCase()=='鑫诺达'" @reback="reback"></xnd>
			<basepriceAdded ref="basepriceAdded" v-show="cwinfo.p_type.toLocaleLowerCase()=='成本价'" @reback="reback"></basepriceAdded>
			
			<ApiPriceAdded ref="ApiPriceAdded" v-show="cwinfo.p_type.toLocaleLowerCase()=='取接口报价'" @reback="reback"></ApiPriceAdded>
			<ApiPriceAddService ref="ApiPriceAddService" v-show="cwinfo.p_type.toLocaleLowerCase()=='取接口报价加签收费保价费附加费'" @reback="reback"></ApiPriceAddService>
			
			<RangeAdded ref="RangeAdded" v-show="cwinfo.p_type.toLocaleLowerCase()=='区间固定运费'" @reback="reback"></RangeAdded>
			<BasePriceAddService ref="BasePriceAddService" v-show="cwinfo.p_type.toLocaleLowerCase()=='成本价加签收费保价费附加费'" @reback="reback"></BasePriceAddService>
		</el-row>
	</div>
</template>
<script>
import BaseAddPercent from '@/components/cw/BaseAddPercent.vue';
import ParentCostAddPercent from '@/components/cw/ParentCostAddPercent.vue';
import DeductionPercent from '@/components/cw/DeductionPercent.vue';	
import yuu from '@/components/cw/yuu.vue';
import xnd from '@/components/cw/xnd.vue';
import ApiPriceAdded from '@/components/cw/ApiPriceAdded.vue';
import basepriceAdded from '@/components/cw/basepriceAdded.vue';
import ApiPriceAddService from '@/components/cw/ApiPriceAddService.vue';
import BasePriceAddService from '@/components/cw/BasePriceAddService.vue';
import RangeAdded from '@/components/cw/RangeAdded.vue';

import Utils from '../../lib/util.js';
export default {
	components: {
		BaseAddPercent,
		ParentCostAddPercent,
		yuu,
		DeductionPercent,
		xnd,
		basepriceAdded,
		ApiPriceAdded,
		ApiPriceAddService,
		RangeAdded,
		BasePriceAddService
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			windowHeight: window.innerHeight - 120,
			showdetail:false,
			describe:'',
			name:'',
			typeindex:-1,
			typelist: [],
			cwinfo:{
				c_name:'',
				remark:'',
				p_type:''
			},
			c_id:'',
			isedit:0
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/cw/setscheme.scss');
			this.GetschemeType();
		});
		if (this.urlparam!= undefined) {
			if (this.urlparam.c_id != undefined) {
				this.c_id = this.urlparam.c_id;
			}
		}
	},
	methods: {
		GetschemeType(){
			var that=this;
			var paraminfo={
				userid:localStorage.getItem('userid')
			}
			this.$apipost.get.GetSchemeType({paraminfo:paraminfo}).then(res => {
				if(res!=''){
					if(res.list.length>0){
						that.Getscheme();
					}
					that.typelist=res.list;
				}
			})
		},
		Getscheme(){
			var that=this;
			if(this.c_id!=''&&this.c_id!=undefined){
				this.isedit='1';
				this.$tool.loading('正在读取方案明细', 'setscheme');
				var paraminfo={
					c_id:this.c_id,
					ismain:1
				}
				this.$apipost.get.Getscheme({paraminfo:paraminfo}).then(res => {
					
					this.$tool.loadingclose();
					if (res != '') {
						if(res.cwinfo!=undefined){
							that.cwinfo=res.cwinfo;
							var p_name='';
							for(let i=0;i<that.typelist.length;i++){
								if(that.typelist[i].d_value.toLocaleString()==that.cwinfo.p_type.toLocaleLowerCase()){
									p_name=that.typelist[i].d_name;
									break;
								}
							}
							if(that.cwinfo.p_type.toLocaleLowerCase()=='baseaddpercent')
							{
								that.showdetail=true;
								if (that.$refs.BaseAddPercent != undefined) {
									that.$refs.BaseAddPercent.init({
										percwinfo:that.cwinfo,
										isedit:'1',
										p_name:p_name
										});
								}
							}
							if(that.cwinfo.p_type.toLocaleLowerCase()=='按上级成本价计算')
							{
								that.showdetail=true;
								if (that.$refs.ParentCostAddPercent != undefined) {
									that.$refs.ParentCostAddPercent.init({
										percwinfo:that.cwinfo,
										isedit:'1',
										p_name:p_name
										});
								}
							}
							if(that.cwinfo.p_type.toLocaleLowerCase()=='云邮出口计费')
							{
								that.showdetail=true;
								if (that.$refs.yuu != undefined) {
									that.$refs.yuu.init({
										percwinfo:that.cwinfo,
										isedit:'1',
										p_name:p_name
										});
								}
							}
							if(that.cwinfo.p_type.toLocaleLowerCase()=='业务提成比例')
							{
								that.showdetail=true;
								if (that.$refs.DeductionPercent != undefined) {
									that.$refs.DeductionPercent.init({
										percwinfo:that.cwinfo,
										isedit:'1',
										p_name:p_name
										});
								}
							}
							if(that.cwinfo.p_type.toLocaleLowerCase()=='鑫诺达')
							{
								that.showdetail=true;
								if (that.$refs.xnd != undefined) {
									that.$refs.xnd.init({
										percwinfo:that.cwinfo,
										isedit:'1',
										p_name:p_name
										});
								}
							}
							if(that.cwinfo.p_type.toLocaleLowerCase()=='成本价')
							{
								that.showdetail=true;
								if (that.$refs.basepriceAdded != undefined) {
									that.$refs.basepriceAdded.init({
										percwinfo:that.cwinfo,
										isedit:'1',
										p_name:p_name
										});
								}
							}
							if(that.cwinfo.p_type.toLocaleLowerCase()=='取接口报价')
							{
								that.showdetail=true;
								if (that.$refs.ApiPriceAdded != undefined) {
									that.$refs.ApiPriceAdded.init({
										percwinfo:that.cwinfo,
										isedit:'1',
										p_name:p_name
										});
								}
							}
							if(that.cwinfo.p_type.toLocaleLowerCase()=='取接口报价加签收费保价费附加费')
							{
								that.showdetail=true;
								if (that.$refs.ApiPriceAddService != undefined) {
									that.$refs.ApiPriceAddService.init({
										percwinfo:that.cwinfo,
										isedit:'1',
										p_name:p_name
										});
								}
							}
							if(that.cwinfo.p_type.toLocaleLowerCase()=='成本价加签收费保价费附加费')
							{
								that.showdetail=true;
								if (that.$refs.BasePriceAddService != undefined) {
									that.$refs.BasePriceAddService.init({
										percwinfo:that.cwinfo,
										isedit:'1',
										p_name:p_name
										});
								}
							}
							if(that.cwinfo.p_type.toLocaleLowerCase()=='区间固定运费')
							{
								that.showdetail=true;
								if (that.$refs.RangeAdded != undefined) {
									that.$refs.RangeAdded.init({
										percwinfo:that.cwinfo,
										isedit:'1',
										p_name:p_name
										});
								}
							}
							
						}else{
							this.$tool.message('读取方案失败，请重新打开', 0);
						}
					}
				});
			}
		},
		//显示明细
		showdescribe(index){
			this.typeindex=index;
			this.name=this.typelist[index].d_name;
			this.describe=this.typelist[index].remark;
		},
		godetail(index){
			this.typeindex=index;
			this.cwinfo.p_type=this.typelist[index].d_value;
			this.showdetail=true;
			if(this.typelist[index].d_value.toLocaleLowerCase()=='baseaddpercent')
			{
				if (this.$refs.BaseAddPercent != undefined) {
					this.$refs.BaseAddPercent.init({percwinfo:this.cwinfo,p_name:this.typelist[index].d_name});
				}
			}
			if(this.typelist[index].d_value.toLocaleLowerCase()=='按上级成本价计算')
			{
				if (this.$refs.ParentCostAddPercent != undefined) {
					this.$refs.ParentCostAddPercent.init({percwinfo:this.cwinfo,p_name:this.typelist[index].d_name});
				}
			}
			if(this.typelist[index].d_value.toLocaleLowerCase()=='云邮出口计费')
			{
				if (this.$refs.yuu != undefined) {
					this.$refs.yuu.init({percwinfo:this.cwinfo,p_name:this.typelist[index].d_name});
				}
			}
			if(this.typelist[index].d_value.toLocaleLowerCase()=='业务提成比例')
			{
				if (this.$refs.DeductionPercent != undefined) {
					this.$refs.DeductionPercent.init({percwinfo:this.cwinfo,p_name:this.typelist[index].d_name});
				}
			}
			if(this.typelist[index].d_value.toLocaleLowerCase()=='鑫诺达')
			{
				if (this.$refs.xnd != undefined) {
					this.$refs.xnd.init({percwinfo:this.cwinfo,p_name:this.typelist[index].d_name});
				}
			}
			if(this.typelist[index].d_value.toLocaleLowerCase()=='成本价')
			{
				if (this.$refs.basepriceAdded != undefined) {
					this.$refs.basepriceAdded.init({percwinfo:this.cwinfo,p_name:this.typelist[index].d_name});
				}
			}
			if(this.typelist[index].d_value.toLocaleLowerCase()=='取接口报价')
			{
				if (this.$refs.ApiPriceAdded != undefined) {
					this.$refs.ApiPriceAdded.init({percwinfo:this.cwinfo,p_name:this.typelist[index].d_name});
				}
			}
			if(this.typelist[index].d_value.toLocaleLowerCase()=='取接口报价加签收费保价费附加费')
			{
				if (this.$refs.ApiPriceAddService != undefined) {
					this.$refs.ApiPriceAddService.init({percwinfo:this.cwinfo,p_name:this.typelist[index].d_name});
				}
			}
			if(this.typelist[index].d_value.toLocaleLowerCase()=='成本价加签收费保价费附加费')
			{
				if (this.$refs.BasePriceAddService != undefined) {
					this.$refs.BasePriceAddService.init({percwinfo:this.cwinfo,p_name:this.typelist[index].d_name});
				}
			}
			if(this.typelist[index].d_value.toLocaleLowerCase()=='区间固定运费')
			{
				if (this.$refs.RangeAdded != undefined) {
					this.$refs.RangeAdded.init({percwinfo:this.cwinfo,p_name:this.typelist[index].d_name});
				}
			}
		},
		reback(e){
			if(this.isedit=='1')
				Utils.$emit('handleRermove', '修改方案');
			else{
				this.showdetail=false;
				this.cwinfo={
					c_name:'',
					remark:'',
					p_type:''
				},
				this.c_id='';
				this.isedit=0;
			}
		}
	}
};
</script>